import axios from "axios";
import { API } from "./api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({
  baseURL: API,
  timeout: 60000,
  withCredentials: true,
});

// Architect endpoints
export const listArchitectDmUsers = (q, limit = 100) =>
  client
    .get(`/architect/dm/users`, { params: { q, limit } })
    .then((r) => r.data);

export const uploadArchitectDmImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client
    .post(`/architect/dm/upload-image`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const sendArchitectDm = (payload) =>
  client.post(`/architect/dm/send`, payload).then((r) => r.data);

export const listArchitectDmSent = (limit = 50) =>
  client.get(`/architect/dm/sent`, { params: { limit } }).then((r) => r.data);

// User endpoints
export const getArchitectInbox = (limit = 100) =>
  client.get(`/architect/dm/inbox`, { params: { limit } }).then((r) => r.data);

export const getArchitectUnreadCount = () =>
  client.get(`/architect/dm/unread-count`).then((r) => r.data);

export const markArchitectDmRead = (messageId) =>
  client.post(`/architect/dm/${messageId}/read`).then((r) => r.data);

export const replyArchitectDm = (messageId, body, imagePath = null, imageContentType = null) =>
  client
    .post(`/architect/dm/${messageId}/reply`, {
      body,
      image_path: imagePath,
      image_content_type: imageContentType,
    })
    .then((r) => r.data);

export const reactArchitectDm = (messageId, emoji) =>
  client
    .post(`/architect/dm/${messageId}/react`, { emoji })
    .then((r) => r.data);

export const dismissArchitectDmBanner = (messageId) =>
  client.post(`/architect/dm/${messageId}/dismiss`).then((r) => r.data);

// Direct image URL — attachments route through the backend with cookie
// auth so the storage_key never touches the browser.
export const architectDmAttachmentUrl = (imagePath) =>
  `${BACKEND_URL}/api/architect/dm/attachment/${imagePath}`;
